<script>

import Pagination from '@/components/pagination'
import Loader from '@/components/widgets/loader'
import {swal, imageError} from '../../../helpers/handle_error';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: { Pagination, Loader },
  data() {
    return {
      //Page errors.
      errors: [],

      //Pagination info.
      showLoader: true,
      page: 1,
      totalPages: 0,
      totalRecords: 0,
      recordsPerPage: 8,
      orderPage: 'desc',
      enterPageNo: null,
    };
  },
  computed:{
    ...mapGetters('post', ['getPosts']),
  },
  methods:{
    imageError,
    ...mapActions('post', ['getAll', 'delete']),
    handleError(error){
      alert(error)
        if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
        else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
    },
    async deleteItem(id) {
      if(await swal.confirm()){
        this.delete(id)
        .then((response)=>{
        swal.success(response.data.message)
        })
        .catch(this.handleError)
      }
    },
    fetchAll(){
      this.getAll({
        per_page: this.recordsPerPage,
        page: this.page,
        order: this.orderPage
      })
      .then((response)=>{
        this.page = response.data.meta.current_page
        this.totalPages = response.data.meta.last_page
        this.totalRecords = response.data.meta.total
        this.showLoader = false
      })
      .catch((error)=>{
        this.handleError(error)
        this.showLoader = false
      })
    },
    onPageChange (page) {
      this.page = page
      this.fetchAll()
    },
    onChangeRecordsPerPage () {
      this.fetchAll()
    },
    gotoPage () {
      if (!isNaN(parseInt(this.enterPageNo))) {
        if(this.enterPageNo > 0 && this.enterPageNo <= this.totalPages){
          this.page = parseInt(this.enterPageNo)
          this.fetchAll()
        }else{
          swal.error(`الصفحات المتوفرة من ( ${1} ) الى ( ${this.totalPages} )`, 'warning')
        }
      }
    }
  },
  created () {
    this.fetchAll()
  },
};
</script>

<template>
  <div>

    <Loader :loading="showLoader" >

    <div class="row mb-3 mt-3">
      <div class="col-md-3">
        <label class="form-label">عرض الاخبار : </label>
        <select class="form-control form-control-sm" @change="onChangeRecordsPerPage" v-model="recordsPerPage">
          <option :value="8">8</option>
          <option :value="16">16</option>
          <option :value="24">24</option>
          <option :value="32">32</option>
          <option :value="40">40</option>
        </select>
      </div>
      <div class="col-md-3"></div>
      <div class="col-md-3"></div>
      <div class="col-md-3">
        <b-form @submit.prevent="gotoPage">
          <label class="form-label">انتقل للصفحة : </label>
          <div class="input-group">
            <input type="number" class="form-control form-control-sm" v-model="enterPageNo" />
            <button class="btn btn-secondary btn-sm" type="submit"> انتقل </button>
          </div>
        </b-form>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3" v-for="post in (getPosts.slice(0, recordsPerPage))" :key="post.id">
        <div class="card p-1 border shadow-none">
          <div class="position-relative">
            <img :src="post.thumbnails.cms" @error="imageError" alt="post image" class="cover-img"/>
          </div>
          <div class="p-3 text-center">
            <p class="text-muted mb-0"> <i class="bx bx-calendar-alt align-middle text-muted me-1"></i> {{ post.created_at }}</p>
            <p class="short-text-2">{{ post.published ? 'منشور':'غير منشور' }} </p>
            <div class="text-center text-muted content-divider mb-1">
              <span class="px-2 short-text-1">{{ post.Title }}</span>
            </div>
            <div class="button-items">
              <a type="button" target="_blank" v-siteRoute="{name:'post', param:{id:post.id}}" class="btn btn-sm btn-primary w-xs">عرض</a>
              <router-link :to="{ name: 'posts.edit', params: { id: post.id } }">
                <b-button v-can="'edit_post'" type="button" class="btn btn-sm btn-warning w-xs">تعديل</b-button>
              </router-link>
              <b-button v-can="'delete_post'" type="button" class="btn btn-sm btn-danger w-xs" @click="deleteItem(post.id)">حذف</b-button>
            </div>
          </div>
        </div>
      </div>
      <h3 v-if="getPosts.length === 0" class="text-center mt-4">لا توجد بيانات لعرضها !</h3>
    </div>

    <Pagination v-if="getPosts" :total-pages="totalPages" :per-page="recordsPerPage" :current-page="page" @pagechanged="onPageChange" />
  </Loader>
  </div>       
</template>